module.exports = __webpack_public_path__ + "img/question-duotone.2b7f10ef.svg";